import { render } from "./IconCloseCircle.vue?vue&type=template&id=fd561cc2"
import script from "./IconCloseCircle.vue?vue&type=script&lang=js"
export * from "./IconCloseCircle.vue?vue&type=script&lang=js"
script.render = render

export default script